import Select from "react-select";

const brandStyles = {
  control: (base, state) => ({
    ...base, minHeight: 48, borderRadius: 12, backgroundColor: "#fff",
    borderColor: state.isFocused ? "#FF7A00" : "#e5e5e5",
    boxShadow: state.isFocused ? "0 0 0 2px rgba(255,122,0,0.2)" : "none",
    "&:hover": { borderColor: "#FF7A00" }, paddingLeft: 6, fontSize: 14,
  }),
  valueContainer: (base) => ({ ...base, padding: "2px 8px" }),
  menuPortal: (base) => ({ ...base, zIndex: 99999 }),
  menu: (base) => ({ ...base, borderRadius: 14, overflow: "hidden", boxShadow: "0 16px 48px rgba(0,0,0,0.16)", zIndex: 99999 }),
  menuList: (base) => ({ ...base, padding: 6 }),
  option: (base, state) => ({
    ...base, borderRadius: 10, cursor: "pointer", fontSize: 14, padding: "10px 12px",
    backgroundColor: state.isSelected ? "#FF7A00" : state.isFocused ? "#FFF3E8" : "#fff",
    color: state.isSelected ? "#fff" : "#171717",
    "&:active": { backgroundColor: "#FF7A00", color: "#fff" },
  }),
  placeholder: (base) => ({ ...base, color: "#a3a3a3" }),
  singleValue: (base) => ({ ...base, color: "#171717" }),
  indicatorSeparator: () => ({ display: "none" }),
  dropdownIndicator: (base, state) => ({ ...base, color: state.isFocused ? "#FF7A00" : "#a3a3a3", transition: "transform .2s", transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "none" }),
};

export function SelectField({ value, onChange, options = [], placeholder = "Select…", isSearchable = false, testId, compact = false, minWidth }) {
  const opts = options.map((o) => (typeof o === "string" ? { value: o, label: o } : o));
  const selected = opts.find((o) => o.value === value) || null;
  const styles = compact
    ? { ...brandStyles, control: (base, state) => ({ ...brandStyles.control(base, state), minHeight: 36, borderRadius: 9999, fontSize: 12, minWidth: minWidth || 130 }) }
    : brandStyles;
  return (
    <div data-testid={testId}>
      <Select
        classNamePrefix="suk-select"
        aria-label={placeholder}
        options={opts}
        value={selected}
        onChange={(o) => onChange(o ? o.value : "")}
        placeholder={placeholder}
        isSearchable={isSearchable}
        menuPortalTarget={typeof document !== "undefined" ? document.body : null}
        menuPosition="fixed"
        menuPlacement="auto"
        styles={styles}
        theme={(t) => ({ ...t, colors: { ...t.colors, primary: "#FF7A00", primary25: "#FFF3E8" } })}
      />
    </div>
  );
}
